<template>
  <div class="min-h-screen px-6 py-8 md:px-10">
    <div class="w-full space-y-6">
      <div class="flex flex-col gap-4 lg:flex-row lg:items-end lg:justify-between">
        <div>
          <h1 class="mt-2 text-3xl text-gray-900">
            Relatório de Sessão
          </h1>
          <p class="mt-2 max-w-2xl text-sm text-gray-500">
            Consulte os horários de login e logout dos operadores.
          </p>
        </div>
      </div>

      <div class="overflow-hidden rounded-2xl border border-gray-200 bg-white shadow-sm">
        <div class="p-6">
          <form>
            <div class="grid grid-cols-1 gap-4 md:grid-cols-5">
              <div class="flex flex-col gap-1">
                <label for="de" class="text-sm font-medium text-gray-500">A partir de</label>
                <input
                  v-model="form.de"
                  type="date"
                  name="de"
                  id="de"
                  class="h-11 rounded-xl border border-gray-200 px-4 shadow-sm outline-none transition-all duration-200 focus:border-blue-100 focus:ring-2 focus:ring-blue-100"
                />
              </div>

              <div class="flex flex-col gap-1">
                <label for="ate" class="text-sm font-medium text-gray-500">Até</label>
                <input
                  v-model="form.ate"
                  type="date"
                  name="ate"
                  id="ate"
                  class="h-11 rounded-xl border border-gray-200 px-4 shadow-sm outline-none transition-all duration-200 focus:border-blue-100 focus:ring-2 focus:ring-blue-100"
                />
              </div>

              <div class="flex flex-col gap-1">
                <label for="operador-select" class="text-sm font-medium text-gray-500">Operador</label>

                <div class="relative group">
                  <select
                    v-model="form.operador"
                    id="operador-select"
                    name="operador"
                    class="w-full h-11 px-4 pr-10 border border-gray-200 rounded-xl bg-white bg-none text-gray-700 shadow-sm appearance-none transition-all duration-200 focus:border-blue-100 focus:ring-2 focus:ring-blue-100 cursor-pointer"
                  >
                    <option :value="null">Todos</option>
                    <option
                      v-for="operador in operadores"
                      :key="operador._id"
                      :value="operador._id"
                    >
                      {{ operador.nome }}
                    </option>
                  </select>

                  <svg class="select-icon h-5 w-5" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                    <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M19 9l-7 7-7-7" />
                  </svg>
                </div>
              </div>

              <div class="flex items-end">
                <button
                  @click="start"
                  type="button"
                  class="h-11 w-full rounded-xl font-medium text-white transition"
                  :style="{ backgroundColor: primaryColor }"
                  @mouseenter="$event.target.style.backgroundColor = mixPrimaryColor('#111827', 0.2)"
                  @mouseleave="$event.target.style.backgroundColor = primaryColor"
                >
                  Filtrar
                </button>
              </div>

              <div class="flex items-end">
                <a
                  target="_blank"
                  :href="`${url}/v1/operador/download/sessao/?token=${token}&operador=${form.operador ? form.operador : ''}&de=${form.de}&ate=${form.ate}`"
                  class="flex h-11 w-full items-center justify-center gap-2 rounded-xl border border-gray-200 bg-white px-4 font-medium text-gray-700 shadow-sm transition hover:bg-gray-50"
                >
                  <svg
                    class="h-5 w-5 text-green-600"
                    fill="none"
                    viewBox="0 0 24 24"
                    stroke="currentColor"
                  >
                    <path
                      stroke-linecap="round"
                      stroke-linejoin="round"
                      stroke-width="2"
                      d="M12 3v12m0 0l-3.5-3.5M12 15l3.5-3.5M4 21h16"
                    />
                  </svg>
                  Download
                </a>
              </div>
            </div>
          </form>
        </div>
      </div>

      <div class="w-full overflow-hidden sm:rounded-lg border border-gray-200 bg-white shadow-sm">
        <div class="overflow-x-auto">
          <table class="w-full min-w-max text-sm">
            <thead class="border-b bg-gray-100 tracking-wider text-gray-600">
              <tr>
                <th class="px-6 py-4 text-left font-medium">Operador</th>
                <th class="px-6 py-4 text-left font-medium">Horário de Login</th>
                <th class="px-6 py-4 text-left font-medium">Horário de Logout</th>
                <th class="px-6 py-4 text-left font-medium">Dia</th>
              </tr>
            </thead>

            <tbody>
              <tr
                v-for="el in lista"
                :key="el._id"
                class="border-b border-gray-100 transition hover:bg-slate-50"
              >
                <td class="px-6 py-5">
                  <div class="flex items-center gap-4">
                    <div class="flex h-11 w-11 items-center justify-center rounded-2xl bg-blue-50 text-sm font-semibold text-blue-700">
                      {{ (el.operador.nome || '').slice(0, 2).toUpperCase() }}
                    </div>

                    <div class="flex flex-col">
                      <span class="font-medium text-gray-800">
                        {{ el.operador.nome }}
                      </span>
                      <span class="text-xs text-gray-400">
                        {{ el.operador.email }}
                      </span>
                    </div>
                  </div>
                </td>

                <td class="px-6 py-5">
                  <span class="rounded-full bg-blue-100 px-3 py-1 text-xs font-medium text-blue-700">
                    {{ el.horarioLogin }}
                  </span>
                </td>

                <td class="px-6 py-5">
                  <span class="rounded-full bg-red-100 px-3 py-1 text-xs font-medium text-red-700">
                    {{ el.horarioLogout || '-' }}
                  </span>
                </td>

                <td class="px-6 py-5 font-medium text-gray-700">
                  {{ moment(el.dia).format('DD/MM/YYYY') }}
                </td>
              </tr>

              <tr v-if="lista.length === 0">
                <td colspan="4" class="px-6 py-12 text-center text-sm text-gray-400">
                  Nenhuma sessão encontrada com os filtros atuais.
                </td>
              </tr>
            </tbody>
          </table>
        </div>
      </div>

      <pagination
        v-model="page"
        :per-page="perPage"
        :records="total"
        @paginate="setPage"
        class="pagination"
      />
    </div>
  </div>
</template>

<script>
import moment from 'moment'
import { colorMixin } from '@/utils/colorMixin';

export default {
  mixins: [colorMixin],
  data() {
    return {
      lista: [],
      moment: moment,
      url: `${window.location.hostname === 'uno.trestto.com.br' ? 'https://uno.trestto.com.br/api' : process.env.VUE_APP_API}`,
      token: this.$store.state.token,
      form: {
        de: moment().format('YYYY-MM-DD'),
        ate: moment().format('YYYY-MM-DD'),
        operador: null
      },
      operadores: [],
      page: 1,
      perPage: 15,
      total: 0
    }
  },
  methods: {
    async setPage(page) {
      this.page = page

      const skip = (page - 1) * this.perPage
      const limit = this.perPage

      const response = await this.$http.post('/v1/operador/sessoes', {
        de: this.form.de,
        ate: this.form.ate,
        operador: this.form.operador,
        limit,
        skip
      })

      if (response.data.success) {
        this.lista = response.data.sessoes || []
        this.total = response.data.total || 0
      }
    },

    async start() {
      this.setPage(1)
    }
  },

  async beforeMount() {
    const operadoresReq = await this.$http.post('/v1/operador/list', {
      all: true,
      chatAcesso: true
    })

    this.operadores = operadoresReq.data.data || []
    this.start()
  }
}
</script>

<style scoped>
.select-icon {
  position: absolute;
  right: 0.75rem;
  top: 50%;
  pointer-events: none;
  color: #9ca3af;
  transform: translateY(-50%);
  transition: transform 0.2s ease, color 0.2s ease;
}

#operador-select::-ms-expand {
  display: none;
}

#operador-select {
  -webkit-appearance: none;
  -moz-appearance: none;
  appearance: none;
  background-image: none !important;
}

.group:focus-within .select-icon {
  color: #6366f1;
  transform: translateY(-50%) rotate(180deg);
}
</style>